import { HttpParams } from '@angular/common/http';

import { Filter } from '../../../../models';

export class ClienteAnaliseMercadoClassificacaoSearchLancamentosFilter implements Filter {
    idsGruposClassificacoes: number[] = [];
    idsClassificacoes: number[] = [];
    classificacaoNull = false;
    idsMetas: number[] = [];
    idMeta: number = null;

    createParams(params: HttpParams): HttpParams {
        if (!params) {
            params = new HttpParams();
        }

        // Grupos de Classificações
        this.idsGruposClassificacoes?.forEach(idGrupoClassificacao => params = params.append('idGrupoClassificacao', idGrupoClassificacao.toString()));

        // Classificações de itens
        this.idsClassificacoes?.forEach(idClassificacao => {
            if (idClassificacao > 0) {
                params = params.append('idClassificacao', idClassificacao.toString());
            }
        });
        // Sem classificação
        if (this.classificacaoNull) {
            params = params.append('classificacaoNull', 'true');
        }

        // Metas
        if (this.idMeta) {
            params = params.append('idMeta', this.idMeta.toString());
        }
        this.idsMetas?.forEach(idMeta => {
            params = params.append('idMeta', idMeta.toString());
        });

        return params;
    }

    clear() {
        this.idsGruposClassificacoes = [];
        this.idsClassificacoes = [];
        this.classificacaoNull = false;
        this.idsMetas = [];
        this.idMeta = null;
    }
}
